import React, { useContext, useEffect, useState } from "react";

import {
  Button,
  Col,
  Modal,
  Row,
  Select,
  Spin,
  Tag,
  message,
  Tabs,
  Card,
  Badge,
  Popconfirm,
} from "antd";

import { Link, useNavigate } from "react-router-dom";
import {
  FaArrowDown,
  FaArrowRight,
  FaInfoCircle,
  FaPlay,
  FaPlus,
  FaRedo,
  FaRegCalendarAlt,
  FaRegCalendarCheck,
} from "react-icons/fa";
import { LoadingOutlined } from "@ant-design/icons";

import FullLoader from "../../../components/FullLoader";
import SearchContext from "../../../Context/SearchContext";
import moment from "moment";

import { MdDelete, MdGarage, MdLiveTv, MdOutlinePending } from "react-icons/md";
import { MdClose } from "react-icons/md";
import { PiGearSixBold } from "react-icons/pi";
// import PlusAdd from "./PlusAdd";
import Countdown from "react-countdown";
import Redo from "./Redo";
const surfaces = {
  firefox:
    "https://storage.googleapis.com/download/storage/v1/b/fussydata/o/3d6a4f8f53c813e804cab34f14353e6b.webp?generation=1711656032042642&alt=media",
  chrome:
    "https://storage.googleapis.com/download/storage/v1/b/fussydata/o/b44cac0229a04d446e175313e7a56af2.webp?generation=1711656220971887&alt=media",
  android:
    "https://storage.googleapis.com/download/storage/v1/b/fussydata/o/a0e9abcdc7a17cfd9a23bed09bc04e2b.png?generation=1711656376081861&alt=media",
  safari:
    "https://storage.googleapis.com/download/storage/v1/b/fussydata/o/eb1f81f5689da43bfaba3041d7b982d6.png?generation=1711656493536641&alt=media",

  apple:
    "https://storage.googleapis.com/download/storage/v1/b/fussydata/o/bcbefe17508b0d515fe1ae71dde28795.png?generation=1711656642662979&alt=media",

  windows:
    "https://storage.googleapis.com/download/storage/v1/b/fussydata/o/cac16ceb2782ee48999f84eecfe61ccb.png?generation=1711656722989961&alt=media",

  edge: "https://storage.googleapis.com/download/storage/v1/b/fussydata/o/135df5fbdf41723604d4a0c84cc749a6.png?generation=1711656299898729&alt=media",
};
export default function Memory() {
  const {
    user,
    gamesData,
    setGamesData,

    organization,
  } = useContext(SearchContext);

  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState();
  const [showC, setShowC] = useState();
  const [loading, setLoadeing] = useState(true);
  const [dDelete, displayDelete] = useState();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  // const [gamesData, setGamesData] = useState();

  const [callApi, setCallApi] = useState(1);
  const { TabPane } = Tabs;

  useEffect(() => {
    if (gamesData.memoryData === undefined || callApi > 1) {
      getlist();
    } else {
      setLoadeing(false);
    }
  }, [callApi]);

  const getlist = () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
    };
    fetch(
      `https://embed.axv.ai/api/feed?page=${gamesData.pageNoMemo}&limit=12&status=watch&live=complete&user_id=${user?.user_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.isSuccess) {
          let all = [];
          if (gamesData.pageNoMemo && gamesData.pageNoMemo > 1) {
            all = gamesData.memoryData.concat(data.feedList);
          } else {
            all = [...data.feedList];
          }
          all = all?.map((obj) => ({ ...obj, key: obj._id }));

          setGamesData({
            ...gamesData,
            memoryData: all,

            totalPagesMemo: data.totalPages,
          });
          if (gamesData.pageNoMemo === 1) {
            setTimeout(() => {
              setCallApi(callApi + 1);
            }, 5000);
          }
        }

        setLoadeing(false);
      });
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
        color: "white",
      }}
      spin
    />
  );

  const deleteTask = (row, key) => {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
    };
    fetch(`https://embed.axv.ai/api/feed/${row._id}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.isSuccess) {
          message.success("Deleted");

          const all = gamesData.oldData2.filter((p) => p._id !== row._id);

          setGamesData({
            ...gamesData,
            memoryData: all,

            totalPagesMemo: data.totalPages,
          });
        } else {
          message.error("Something Went Wrong");
        }
      });
  };

  const emptyAlert = () => {
    return (
      <div class="notifications-container">
        <div class="dad-joke">
          <div class="flex">
            <div class="flex-shrink-0">
              <FaInfoCircle class="dad-joke-svg" />
            </div>
            <div class="dad-joke-prompt-wrap">
              <p class="dad-joke-prompt-heading">Dad Jokes Alert!</p>
              <div class="dad-joke-prompt">
                <p>
                  Why don’t scientists trust atoms? Because they make up
                  everything.
                </p>
              </div>
              <div class="dad-joke-button-container flex-end">
                <button class="dad-joke-button-main" type="button">
                  Undefined
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <div style={{ width: "100%" }} className="active-goals-tc21">
        {/* <h5 style={{ textAlign: "center" }}>Live Machines</h5> */}

        <div className="assets-bx-h1">
          {gamesData.memoryData === undefined ? (
            <div className="box-loading">
              <FullLoader />
            </div>
          ) : null}
          {gamesData.memoryData && gamesData.memoryData.length === 0 ? (
            <div className="center-alert-c"> {emptyAlert()}</div>
          ) : null}
          <Row>
            {gamesData.memoryData &&
              gamesData.memoryData.map((m, mi) => {
                return (
                  <Col
                    lg={{ span: 8 }}
                    md={{ span: 8 }}
                    key={mi}
                    //   className="display-goal-st-s"
                    style={{ padding: "15px" }}
                  >
                    <div
                      style={{
                        backgroundImage: `url(${
                          m.thumbnail
                            ? m.thumbnail
                            : "https://storage.googleapis.com/download/storage/v1/b/fussydata/o/a9331ac8e94adeeea5617da8ce2bd099.png?generation=1712749470412327&alt=media"
                        })`,
                      }}
                      class="c3-card"
                    >
                      <div class="c3-svg show-hover ">
                        <Popconfirm
                          title="Do You Want to Delete?"
                          onConfirm={() => deleteTask(m)}
                          // onCancel={cancel}
                          okText="Yes"
                          cancelText="No"
                          placement="top"
                        >
                          <MdClose />
                        </Popconfirm>
                      </div>
                      <div className="public-top-c">
                        <b>{m.title}</b>
                      </div>

                      <div class="c3-logo">
                        <b>
                          <img
                            style={{ width: "30px" }}
                            src={surfaces[m.channelUuid]}
                            alt=""
                          />
                        </b>
                      </div>
                      <div class="c3-title">
                        <a href={`https://u.computer/${m._id}`} target="blank">
                          <div
                            onClick={() => navigate(`/community/${m._id}`)}
                            className="right-arrow-public"
                          >
                            <FaPlay />
                          </div>
                        </a>

                        <br />
                      </div>

                      <div class="c3-icons-container">
                        <div className="c323-icons-container">
                          <FaRegCalendarAlt
                            onClick={() => navigate(`/live/sessions/${m._id}`)}
                            class="c3-svg "
                          />
                          {/* <PlusAdd /> */}
                          <Redo row={m} />
                        </div>
                        <i> {moment(m.date).format("LL")}</i>
                      </div>
                    </div>
                  </Col>
                );
              })}
          </Row>

          {gamesData.totalPagesMemo &&
          gamesData.totalPagesMemo > gamesData.pageNoMemo ? (
            <div className="load-more-btn">
              {loading ? (
                <Spin indicator={antIcon} />
              ) : (
                <Tag
                  onClick={() => {
                    setGamesData({
                      ...gamesData,
                      pageNoMemo: gamesData.pageNoMemo + 1,
                    });
                    setLoadeing(true);
                    setCallApi(callApi + 1);
                  }}
                  className={`editor-tag-tab  active-tg-wdt`}
                >
                  Load More <FaArrowDown />
                </Tag>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
